import { createSlice } from "@reduxjs/toolkit";

let initialState = {
  services: [],
  servicesMeta: {
    limit: 10,
    total: 0,
    offset: 0,
  },
  customers: [],
  customersMeta: {
    limit: 10,
    total: 0,
    offset: 0,
  },
  invoices: [],
  invoiceMeta: {
    limit: 10,
    total: 0,
    offset: 0,
  },
};

export const invoiceSlice = createSlice({
  name: "invoice",
  initialState,
  reducers: {
    setServices: (state, action) => {
      state.services = action.payload;
    },
    addInvoiceServices: (state, action) => {
      state.services = [...action.payload, ...state.services];
    },
    updateInvoiceService: (state, action) => {
      state.services = state?.services?.map((service) =>
        action?.payload?._id === service?._id ? action.payload : service
      );
    },
    deleteInvoiceService: (state, action) => {
      state.services = state?.services?.filter(
        (service) => action?.payload?._id !== service?._id
      );
    },
    setServicesMeta: (state, action) => {
      state.servicesMeta = action.payload;
    },
    setCustomers: (state, action) => {
      state.customers = action.payload;
    },
    addInvoiceCustomers: (state, action) => {
      state.customers = [...action.payload, ...state.customers];
    },
    setCustomersMeta: (state, action) => {
      state.customersMeta = action.payload;
    },
    updateInvoiceCustomer: (state, action) => {
      state.customers = state?.customers?.map((customer) =>
        action?.payload?._id === customer?._id ? action.payload : customer
      );
    },
    deleteInvoiceCustomer: (state, action) => {
      state.customers = state?.customers?.filter(
        (customer) => action?.payload?._id !== customer?._id
      );
    },
    setInvoices: (state, action) => {
      state.invoices = action.payload;
    },
    addInvoice: (state, action) => {
      state.invoices = [...action.payload, ...state.invoices];
    },
    setInvoiceMeta: (state, action) => {
      state.invoiceMeta = action.payload;
    },
    updateInvoice: (state, action) => {
      state.invoices = state?.invoices?.map((invoice) =>
        action?.payload?._id === invoice?._id ? action.payload : invoice
      );
    },
  },
});

export const {
  setServices,
  addInvoiceServices,
  setInvoiceMeta,
  setServicesMeta,
  deleteInvoiceService,
  setCustomers,
  addInvoiceCustomers,
  setCustomersMeta,
  updateInvoiceCustomer,
  deleteInvoiceCustomer,
  setInvoices,
  addInvoice,
  updateInvoice,
  updateInvoiceService,
} = invoiceSlice.actions;

export default invoiceSlice.reducer;
